import { render, staticRenderFns } from "./loadModel.vue?vue&type=template&id=3244a054&"
import script from "./loadModel.vue?vue&type=script&lang=js&"
export * from "./loadModel.vue?vue&type=script&lang=js&"
import style0 from "./loadModel.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports